module.exports = __webpack_public_path__ + "img/god.321f0827.png";